<h2>Recupear contraseña</h2>

<form [formGroup]="form"> 
<mat-dialog-content style="min-width: 700px; min-height: auto;">
    <table>   
        <tr>
            <td><p style="width: 100%;
                text-align: left;
                font-size: 20px;
                color: #4C4D55;
                opacity: 1;font-weight: bold;"
                >Ingresar Código Jardín</p>
            </td>
            
            <td>
                <mat-form-field>
                    <input matInput  type="text" formControlName="rbd" required  id="rbd" 
                    style="background: #d6dcfa 0% 0% no-repeat padding-box; border-radius: 10px;border:1px;  min-height: 32px;min-width: 300px">

                    <mat-error *ngIf="form.hasError('required', 'rbd')">
                        Codigo Jardín es requerida
                    </mat-error>
                    
                </mat-form-field>  
            </td>
        </tr>        
    </table>  

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close class="btn-cancelar">Cancel</button>
    <button mat-button (click)="confirmar()" class="btn-confirmar" [disabled]="!form.valid">Aceptar</button>
  </mat-dialog-actions>
</form>